import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import api from "@/lib/api";

export default function StoryReader() {
  const { slug } = useParams();
  const [story, setStory] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    setStory(null);
    setMissing(false);
    api.get(`/stories/${slug}`).then((r) => setStory(r.data)).catch(() => setMissing(true));
    window.scrollTo(0, 0);
  }, [slug]);

  return (
    <main className="min-h-screen bg-sand-50 text-sand-900">
      <header className="border-b border-sand-200/70 bg-sand-50/85 backdrop-blur-md sticky top-0 z-40">
        <div className="max-w-2xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="reader-wordmark" className="font-serif italic text-2xl tracking-widest text-sand-900">
            Frank en Vrij
          </Link>
          <Link
            to="/"
            data-testid="reader-back-link"
            className="font-sans text-xs font-light tracking-[0.2em] uppercase text-sand-900/60 hover:text-terracotta-500 transition-colors"
          >
            ← Terug
          </Link>
        </div>
      </header>

      {missing && (
        <p data-testid="story-not-found" className="max-w-2xl mx-auto px-6 py-32 font-serif italic text-2xl font-light text-sand-900/50">
          Dit verhaal is (nog) niet te vinden.
        </p>
      )}

      {story && (
        <motion.article
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-2xl mx-auto px-6 py-20 sm:py-28"
          data-testid="story-reader"
        >
          <p className="font-sans text-xs font-light tracking-[0.35em] uppercase text-terracotta-500 mb-6">
            Verhaal
          </p>
          <h1 className="font-serif text-4xl sm:text-6xl font-light tracking-tighter leading-[1.05] text-sand-900">
            {story.title}
          </h1>
          <p className="mt-6 font-sans text-xs font-light tracking-[0.2em] uppercase text-sand-900/40">
            {new Date(story.created_at).toLocaleDateString("nl-NL", { day: "numeric", month: "long", year: "numeric" })}
          </p>
          <div className="mt-14 space-y-8">
            {story.content.split(/\n\s*\n/).map((para, i) => (
              <p
                key={i}
                className={`font-serif text-xl sm:text-2xl font-light leading-[1.9] text-sand-900/85 ${i === 0 ? "dropcap" : ""}`}
              >
                {para}
              </p>
            ))}
          </div>
          <div className="mt-20 pt-10 border-t border-sand-200">
            <p className="font-serif italic text-2xl text-sand-900/60">— Frank en Vrij</p>
          </div>
        </motion.article>
      )}
    </main>
  );
}
